var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
      staticClass: "main_center clearfix",
    },
    [
      _c("div", { staticClass: "top-content" }, [
        _c(
          "div",
          { staticClass: "left-navbar" },
          [
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.backBtn } },
              [_vm._v("返回")]
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-right": "10px" },
                attrs: { type: "primary", size: "small", plain: "" },
                on: {
                  click: function ($event) {
                    return _vm.save()
                  },
                },
              },
              [_vm._v("保存")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "150px" },
        },
        [
          _c(
            "div",
            { staticClass: "right-content" },
            [
              _c(
                "el-card",
                { staticClass: "box-card", style: { height: _vm.cardHight } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v("配置信息")])]
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { label: "名称：", prop: "name" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "50",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.form.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "name", $$v)
                                  },
                                  expression: "form.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { label: "流id：", prop: "streamId" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "50",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.form.streamId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "streamId", $$v)
                                  },
                                  expression: "form.streamId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: "流媒体地址：",
                                prop: "streamUrl",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "255",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.form.streamUrl,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "streamUrl", $$v)
                                  },
                                  expression: "form.streamUrl",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "location", label: "场地楼层：" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.form.location,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "location", $$v)
                                    },
                                    expression: "form.location",
                                  },
                                },
                                _vm._l(_vm.filedFloorOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.name,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "tradeOrgId",
                                label: "所属交易中心：",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.form.tradeOrgId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "tradeOrgId", $$v)
                                    },
                                    expression: "form.tradeOrgId",
                                  },
                                },
                                _vm._l(_vm.traddingList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.orgName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { label: "发布：", prop: "pubFlag" },
                            },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("el-switch", {
                                    attrs: {
                                      "active-value": 1,
                                      "inactive-value": 0,
                                      "active-color": "#13ce66",
                                      "inactive-color": "#c0c0c0",
                                    },
                                    model: {
                                      value: _vm.form.pubFlag,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "pubFlag", $$v)
                                      },
                                      expression: "form.pubFlag",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }